const MediaBorders = {
  huge: "1440px",
  large: "1206px",
  medium: "1024px",
  umedium: "1025px",
  small: "450px",
  tiny: "320px"
};

export default MediaBorders;



// WEBPACK FOOTER //
// ./src/constants/media-borders.js